/*
* @Author: Abhi Bhatt
* @Date:   2020-07-21 13:53:37
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-03-12 10:21:41
*/


import React from 'react';
import {Link} from 'react-router-dom';
import SearchService from './../../services/SearchService/SearchService';
import SideBar from '../../components/SideBar/SideBar';
import queryString from 'query-string';

class SearchMotorInventory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			motor_inventory:{},
			is_login:0,
			searchString:'',
			inventory_places:{}
		}
		this.searchService = new SearchService();
		this.renderInventoryTableHead = this.renderInventoryTableHead.bind(this);

	}

	componentDidMount() {
		const search = window.location.search;
		const params = new URLSearchParams(search);
		if(params!=='') {
			this.searchService.searchMotorInventory(params).then(response=>{
				if(response.status===200){
					this.setState({motor_inventory:response.data.result.motor_inventory});
					this.setState({inventory_places:response.data.result.inventory_places});
				}
			})
		}
		if(localStorage.getItem('techtop_user_id')!='' && localStorage.getItem('techtop_user_id')!=null) {
			this.setState({is_login:1});
		}

		let searchString = '';
		let url = this.props.location.search;
		let searchParams = queryString.parse(url);
		//if(searchParams.length>0){
			Object.keys(searchParams).map(function(value,key){
				if(value!==''){
					searchString+=value+'='+searchParams[value]+'&'
				}
			});
		//}
		this.setState({searchString:searchString});
	}

	/*componentDidUpdate(prevProps, prevState){
		const search = window.location.search;
		const params = new URLSearchParams(search);
		if(params !== prevProps.params) {
			alert(prevProps.params+' -- '+params);
			this.searchService.searchMotorInventory(params).then(response=>{
				if(response.status===200){
					this.setState({search_data:response.data.result});
				}
			})
		}
	}*/

	renderInventoryTableHead() {
		let inventory_places = this.state.inventory_places;
		let motor_inventory = this.state.motor_inventory;
		if(inventory_places && inventory_places.length>0) {
			return(
				<React.Fragment>
					<table className="table mt-5">
						<thead>
							<tr>
								<th>Model Number</th>
								{Object(inventory_places).map(function(value,key){
									return (<React.Fragment key={key}><th>{value.fields.name}</th></React.Fragment>)
								})}
							</tr>
						</thead>
						<tbody>
							{(motor_inventory && motor_inventory.length>0)?
								Object(motor_inventory).map(function(value1,key1){
									return(
										<React.Fragment key={key1}>
											<tr>
												<th><Link to={'/motors/'+value1.fields.part_number}>{value1.fields.part_number}</Link></th>
												{Object(value1.inventory_places).map(function(value2,key2){
													return(<React.Fragment key={key1+'-'+key2}><th>{value2.fields.count}</th></React.Fragment>)
												})}
											</tr>
										</React.Fragment>
									)
								})
							:''}

						</tbody>
					</table>
				</React.Fragment>
			)
		}

	}

	render() {
		let searchString = this.state.searchString;
		return(
			<React.Fragment>
				<main role="main" className="middle-content-area">
					<div className="container-fluid">
						<section className="product-area my-1">		
							<div className="row">
								<div className="col-md-12">
									<ol className="breadcrumb">
										<li className="breadcrumb-item"><a href="/">Home</a><i className="fas fa-angle-right"></i></li>
										<li className="breadcrumb-item"><a href="/products/">Products</a><i className="fas fa-angle-right"></i></li>
									</ol>
								</div>
							</div>		
							<div className="row">
								<div className="col-md-3 col-sm-12 col-xl-2 col-lg-3 col-12">
									<SideBar/>
								</div>
								<div className="col-md-8 col-sm-12 col-xl-8 col-lg-8 col-12">
									<div className="products">
										<div className="row">
											<div className="col-md-8">
												<h3><strong>Search Results</strong></h3>
											</div>
											<div className="col-md-4 text-right">
												<p><Link to={`/search-motor/?${searchString}`}>Show Specs Table</Link></p>
											</div>	
										</div>	
										<div className="row">
											<div className="col-md-12 mb-2">
												<article className="motors">
													{this.renderInventoryTableHead()}
												</article>	
											</div>	
										</div>	
								
									</div>
								</div>
							</div>
						</section>
					</div>	
				</main>
			</React.Fragment>
		)
	}
}

export default SearchMotorInventory;